var map = {
	"./audio-muted.svg": 3504,
	"./audio.svg": 6889,
	"./copy.svg": 1002,
	"./github.svg": 4211,
	"./language.svg": 4884,
	"./video-muted.svg": 5756,
	"./video.svg": 1671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;